import { render, staticRenderFns } from "./TreeCategoryAdd.vue?vue&type=template&id=a94b0054&scoped=true&"
import script from "./TreeCategoryAdd.vue?vue&type=script&lang=js&"
export * from "./TreeCategoryAdd.vue?vue&type=script&lang=js&"
import style0 from "./TreeCategoryAdd.vue?vue&type=style&index=0&id=a94b0054&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94b0054",
  null
  
)

export default component.exports